export default "__VITE_ASSET__CvN3X6h1__"